import React, { Component } from 'react';

export class ErrorBoundary extends Component {
    state = { hasError: false };
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        sendErrorToServer(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return <h1>Ой, щось пішло не так!</h1>;
        }
        return this.props.children;
    }
}

function sendErrorToServer(moduleName, errorInfo) {
    console.log(moduleName, errorInfo);
}
